<div class="layout-wrapper" [ngClass]="{
    'layout-overlay': configService.menuMode === 'overlay',
    'layout-static': configService.menuMode === 'static',
    'layout-slim': configService.menuMode === 'slim',
    'layout-horizontal': configService.menuMode === 'horizontal',
    'layout-sidebar-dim': themeService.colorScheme === 'dim',
    'layout-sidebar-dark': themeService.colorScheme === 'dark',
    'layout-overlay-active': overlayMenuActive,
    'layout-mobile-active': staticMenuMobileActive,
    'layout-static-inactive': staticMenuDesktopInactive && configService.menuMode === 'static',
    'p-input-filled': configService.inputStyle === 'filled',
    'p-ripple-disabled': !configService.ripple}"
     [class]="themeService.colorScheme === 'light' ? configService.menuTheme : ''"
     [attr.data-theme]="themeService.colorScheme" (click)="onLayoutClick()">

    <div class="layout-content-wrapper">
        <app-topbar></app-topbar>

        <div class="layout-content">
            <router-outlet></router-outlet>
        </div>
    </div>

    <app-rightmenu></app-rightmenu>
</div>
